import { Post } from "@/src/models/post.model";

/**
 * What it means for a post to belong to a group's feed.
 *
 * A post created inside a group carries the group in `groupId`. A post composed
 * elsewhere and targeted at the group carries it in `visibleToGroupIds` instead.
 * Both belong to that group; nothing else does.
 *
 * The server-side filter and the client-side predicate below are kept in one
 * file on purpose — they express the same rule and drifting apart is how a post
 * ends up fetched for a group feed but hidden in it, or worse, the other way
 * round.
 */

/** `postFilterInput` fragment scoping a `getposts` query to one group. */
export const groupScopeWhere = (groupId: string) => ({
  or: [
    { groupId: { eq: groupId } },
    { visibleToGroupIds: { in: [groupId] } },
  ],
});

/** Same rule as `groupScopeWhere`, applied to an already-fetched post. */
export const postBelongsToGroup = (
  post: Pick<Post, "groupId" | "visibleToGroupIds">,
  groupId: string,
) =>
  post.groupId === groupId ||
  (post.visibleToGroupIds?.includes(groupId) ?? false);
